'use client'
import Image from 'next/image'
import React, { useState, useEffect } from 'react'

const AboutFruit = () => {
  const [activeStep, setActiveStep] = useState(0)
  const [isDesktop, setIsDesktop] = useState(false)

  useEffect(() => {
    const checkWidth = () => setIsDesktop(window.innerWidth >= 1024)
    checkWidth()
    window.addEventListener('resize', checkWidth)
    return () => window.removeEventListener('resize', checkWidth)
  }, [])

  const description = [
    {
      title: 'About monk fruit',
      description:
        'Monk fruit is a small, natural sweet fruit used for over 1,300 years. It naturally triggers your taste buds to perceive sweetness without ever spiking your blood glucose levels. The body simply passes it through completely unused within 24–48 hours',
      image: '/images/about-fruit-img1.jpg'
    },
    {
      title: "How is it made?",
      description:
        'We harvest and dry the pure monk fruit. The pulp is gently treated to extract mogroside V—the clean compound responsible for its incredible, sugar-like taste. We then blend it cleanly without using any gut-wrecking erythritol.',
      image: '/images/about-fruit-img2.jpg'
    },
    {
      title: 'Is it safe?',
      description:
        'It is 100% safe. Monk fruit has a history of safe use going back centuries and is fully US-FDA approved. Leading clean food brands across the globe trust it because it has absolutely zero chemical side effects or digestive issues',
      image: '/images/about-fruit-img3.jpg'
    },
    {
      title: "What's the catch?",
      description:
        'No catch here. It tastes identical to sugar, bakes perfectly, leaves zero bitter aftertaste, and contains 0 calories. We made this because we believe you deserve absolute, unfiltered sweetness without paying for it with your health.',
      image: '/images/about-fruit-img4.jpg'
    }
  ]

  return (
    <section className="site-container">
      <div
        className="grid max-sm:grid-cols-1 max-md:grid-cols-2 lg:grid-cols-4 gap-5 transition-[grid-template-columns] duration-500 ease-in-out min-h-[430px]"
        style={{
          gridTemplateColumns: isDesktop
            ? description
                .map((_, i) => (activeStep === i ? '3fr' : '1fr'))
                .join(' ')
            : undefined
        }}
      >
        {description.map((items, index) => (
          <div
            key={index}
            onMouseEnter={() => setActiveStep(index)}
            className={`flex flex-col ${
              index === description.length - 1
                ? ''
                : 'md:border-r lg:border-[#CECECE] gap-2'
            } cursor-pointer`}
          >
            <h3
              className={`${
                activeStep === index ? 'text-primary' : 'text-black'
              } flex flex-col max-sm:text-[20px] text-[25px]`}
            >
              <span>0{index + 1}.</span>
              {items?.title}
            </h3>
            <p
              className={`w-full max-w-[400px] transition-all duration-500 ease-in-out ${
                activeStep === index
                  ? 'opacity-100 translate-y-0 max-h-40 mt-2'
                  : 'opacity-0 -translate-y-2 max-h-0 mt-0'
              }`}
            >
              {items.description}
            </p>
            <div
              className={`transition-opacity duration-500 ease-in-out ${
                activeStep === index ? 'opacity-100 max-h-[400px] mt-4' : 'opacity-0 max-h-0 mt-0'
              }`}
            >
              <Image
                src={items?.image}
                alt={items?.title || 'About Good Sugar'}
                width={400}
                height={100}
                quality={100}
                className={activeStep === index ? 'block' : 'invisible'}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default AboutFruit
